import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const RootRedirect: React.FC = () => {
  const location = useLocation();
  const lastRoute = sessionStorage.getItem('budget_app_last_route');
  // Validate the stored route is a safe relative path (not a protocol-relative URL like //evil.com)
  const isValidRoute = lastRoute != null && lastRoute.startsWith('/') && !lastRoute.startsWith('//');
  const target = isValidRoute ? lastRoute : '/landing';

  // Preserve query string (e.g. ?code=… from OAuth callback) so the auth
  // library can process it after the redirect.
  return <Navigate to={target + location.search} replace />;
};
